// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/setup/env';

import Vue from 'vue';
import App from './App';
import store from '@/core/store';
import router from '@/core/routes';

// DEV ENV ONLY
import '@/setup/devlog.js';

import '@/setup/sw.js';
import '@/setup/polyfills.js';
import '@/setup/vue.js';
import '@/setup/gtm.js';
import '@/setup/sentry.js';
import '@/setup/interop.js';
import '@/setup/sounds.js';
import '@/setup/permissions';
import { configureApiService } from '@/setup/api.js';
configureApiService(store);

import { i18n } from '@/setup/i18n.js';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render (h) {
    return h(App);
  },
  components: { App },
});
